import React from 'react';
import { Switch } from 'react-router';
import PrivateRoute from '../../components/PrivateRoute';
import TermYearListPage from './TermYearListPage.js';
import TermYearForm from '../../components/term_year/TermYearForm';

export default () => (
  <Switch>
    <PrivateRoute
      exact
      path="/etapas/anos"
      permission="academico.can_view_term_year"
      component={TermYearListPage}
    />
    <PrivateRoute
      exact
      path="/etapas/anos/new"
      permission="academico.can_add_term_year"
      component={TermYearForm}
    />
    <PrivateRoute
      exact
      path="/etapas/anos/:id/edit"
      permission="academico.can_change_term_year"
      component={TermYearForm}
    />
  </Switch>
);
